var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0938 14.0625V13.2812H19.5312V14.0625H17.9688V13.2812H16.4062V14.0625H15.625V9.375H14.8438V8.59375H13.2812V9.375H11.7188V8.59375H10.1562V9.375H9.375V4.6875H8.59375V3.90625H7.03125V4.6875H5.46875V3.90625H3.90625V4.6875H3.125V20.3125H21.875V14.0625H21.0938ZM4.6875 6.25H7.8125V9.375H4.6875V6.25ZM4.6875 10.9375H14.0625V14.0625H4.6875V10.9375ZM8.59375 18.75H4.6875V15.625H8.59375V18.75ZM20.3125 18.75H10.1562V15.625H20.3125V18.75Z",
    fill: "#D1F27A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuild);
export default __webpack_public_path__ + "static/media/ic_build.6f5633135fbfca2ecc5389788222aab7.svg";
export { ForwardRef as ReactComponent };